module.exports = __webpack_public_path__ + "static/media/alipay.8ef0f0ea.jpeg";